import createEmotionServer from '../create-instance/dist/emotion-server-create-instance.browser.esm.js';
import 'through';
import 'html-tokenize';
import 'multipipe';
import { cache } from '@emotion/css';

var _createEmotionServer = createEmotionServer(cache),
    extractCritical = _createEmotionServer.extractCritical,
    extractCriticalToChunks = _createEmotionServer.extractCriticalToChunks,
    renderStylesToString = _createEmotionServer.renderStylesToString,
    renderStylesToNodeStream = _createEmotionServer.renderStylesToNodeStream,
    constructStyleTagsFromChunks = _createEmotionServer.constructStyleTagsFromChunks;

export { constructStyleTagsFromChunks, extractCritical, extractCriticalToChunks, renderStylesToNodeStream, renderStylesToString };
